<div class="vrc-bloco" [formGroup]="recebimento">
  <!-- Cabeçalho do recebimento (§8.0): ícone da forma, título fixo, n/N e excluir. A forma escolhida
       aparece só no select, então trocar a forma não muda o título. -->
  <div class="vrc-cabecalho">
    <mat-icon class="material-symbols-outlined vrc-icone">{{ perfil.icone }}</mat-icon>
    <span class="vrc-titulo">Recebimento</span>
    <span class="vrc-contador">{{ contador }}</span>
    @if (!isSomenteLeitura) {
      <button type="button" mat-icon-button class="icon-mat-symbols-btn" matTooltip="Excluir recebimento" (click)="excluir.emit()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
      </button>
    }
  </div>

  <!-- Forma e Valor são sempre os dois primeiros campos (§8.0). -->
  <div class="row">
    <div class="col-12 col-md-6">
      <app-select-pesquisavel
        [control]="formaControl"
        [offlineList]="formas"
        label="Forma de recebimento"
        idField="id"
        nameField="descricao"
        [disabled]="isSomenteLeitura"
        (selectionChange)="aoTrocarForma()">
      </app-select-pesquisavel>
    </div>

    <div class="col-12 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor</mat-label>
        <input matInput formControlName="valor" [currencyMask]="mascaraDinheiro" class="vrc-num"
          [readonly]="isSomenteLeitura">
      </mat-form-field>
    </div>

    @if (forma && perfil.categoria) {
      <div class="col-12 col-md-3">
        <app-select-pesquisavel
          [control]="categoriaControl"
          [offlineList]="categorias"
          label="Categoria"
          idField="id"
          nameField="descricao"
          [isOptional]="true"
          [disabled]="isSomenteLeitura">
        </app-select-pesquisavel>
      </div>
    }
  </div>

  @if (forma) {
    <!-- Campos que a NATUREZA da forma traz (§8.3). Intermediador sempre antes de Bandeira. -->
    <div class="row">
      @if (perfil.intermediacao === 'meio') {
        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Meio</mat-label>
            <mat-select [value]="meio" [disabled]="isSomenteLeitura" (selectionChange)="aoTrocarMeio($event.value)">
              <mat-option value="banco">Banco</mat-option>
              <mat-option value="intermediador">Intermediador</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }

      @if (perfil.intermediacao === 'cartao' || (perfil.intermediacao === 'meio' && meio === 'intermediador')) {
        <div class="col-12 col-md-4">
          <app-select-pesquisavel
            [control]="intermediadorControl"
            [offlineList]="intermediadoresDaForma"
            label="Intermediador de pagamento"
            idField="idIntermediadorPagamento"
            nameField="descricao"
            [disabled]="isSomenteLeitura"
            [hint]="hintIntermediador"
            (selectionChange)="aoTrocarDependente()">
          </app-select-pesquisavel>
        </div>
      }

      @if (perfil.bandeira) {
        <div class="col-12 col-md-3">
          <app-select-pesquisavel
            [control]="bandeiraControl"
            [offlineList]="bandeiras"
            label="Bandeira"
            idField="idBandeira"
            nameField="descricao"
            [isOptional]="true"
            [disabled]="isSomenteLeitura || !intermediador"
            [hint]="!intermediador ? 'Escolha o intermediador primeiro' : ''"
            (selectionChange)="aoTrocarDependente()">
          </app-select-pesquisavel>
        </div>
      }

      @if (perfil.contaBancaria || (perfil.intermediacao === 'meio' && meio === 'banco')) {
        <div class="col-12 col-md-4">
          <app-select-pesquisavel
            [control]="contaControl"
            [offlineList]="contasBancariasDaForma"
            label="Conta bancária"
            idField="idContaFinanceira"
            nameField="descricao"
            [disabled]="isSomenteLeitura || !temContaBancaria"
            [hint]="hintContaBancaria">
          </app-select-pesquisavel>
        </div>
      }

      @if (perfil.contaDeRecebimento === 'contaCaixa') {
        <div class="col-12 col-md-4">
          <app-select-pesquisavel
            [control]="contaControl"
            [offlineList]="contasCaixa"
            label="Conta caixa"
            idField="idContaFinanceira"
            nameField="descricao"
            [disabled]="isSomenteLeitura">
          </app-select-pesquisavel>
        </div>
      }

      @if (perfil.contaDeRecebimento === 'editavel' || perfil.contaDeRecebimento === 'obrigatoria') {
        <div class="col-12 col-md-4">
          <app-select-pesquisavel
            [control]="contaControl"
            [offlineList]="contasDaForma"
            label="Conta de recebimento"
            idField="idContaFinanceira"
            nameField="descricao"
            [isOptional]="perfil.contaDeRecebimento !== 'obrigatoria'"
            [disabled]="isSomenteLeitura">
          </app-select-pesquisavel>
        </div>
      }

      @if (contaEmLeitura) {
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Conta de recebimento</mat-label>
            <input matInput [value]="contaEmLeitura" disabled>
          </mat-form-field>
        </div>
      }
    </div>

    <!-- Nota de mecanismo (§8.4): faixa neutra com ícone. Quebra em várias linhas só a orientação de conta. -->
    @if (nota) {
      <app-alert-card type="neutral" class="vrc-nota">{{ nota }}</app-alert-card>
    }

    <!-- Condição de pagamento (§8.5): texto livre, select cadastrado, ou o parcelamento da operadora. -->
    @if (perfil.condicao) {
      <div class="row align-items-start">
        @if (perfil.condicaoDaOperadora) {
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Condição de pagamento</mat-label>
              <mat-select [formControl]="operadoraEscolhida" (selectionChange)="gerarParcelas(false)">
                @for (o of opcoesDaOperadora; track o.id) {
                  <mat-option [value]="o.id">
                    {{ o.descricao }}{{ o.taxa != null ? ' — taxa ' + (o.taxa | abnt: 'quantidade' : 2) + '%' : '' }}
                  </mat-option>
                }
              </mat-select>
              @if (!intermediador) {
                <mat-hint>Selecione o intermediador de pagamento.</mat-hint>
              }
            </mat-form-field>
          </div>
        } @else if (usaCondicaoLivre) {
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Condição de pagamento</mat-label>
              <input matInput formControlName="condicaoPagamentoLivre" placeholder='Ex.: "30 60", "3x", "15 +2x"'
                [readonly]="isSomenteLeitura">
              <mat-hint>N = uma parcela em N dias · Nx = N parcelas a cada 30 dias</mat-hint>
            </mat-form-field>
          </div>
        } @else {
          <div class="col-12 col-md-5">
            <app-select-pesquisavel
              [control]="condicaoControl"
              [offlineList]="condicoesAplicaveis"
              label="Condição de pagamento"
              idField="idCondicaoPagamento"
              nameField="nome"
              [disabled]="isSomenteLeitura"
              (selectionChange)="aoEscolherCondicao()">
            </app-select-pesquisavel>
          </div>
        }

        @if (perfil.grade && !isSomenteLeitura) {
          <div class="col-12 col-md-3 vrc-gerar">
            <button type="button" mat-stroked-button class="btn-secondary" (click)="gerarParcelas()">
              <mat-icon class="material-symbols-outlined">autorenew</mat-icon> {{ rotuloGerar }}
            </button>
          </div>
        }
      </div>

      <!-- Prévia do lançamento (T07): pelo intermediador, vencimento pelo prazo, taxa, tarifa e líquido por parcela;
           pela condição cadastrada, os juros previstos. Só exibição: o orquestrador calcula de novo ao lançar. -->
      @if (simulacao; as s) {
        @if (s.daOperadora) {
          <div class="vrc-previa">
            <table class="vrc-previa-tabela">
              <thead>
                <tr>
                  <th>Parcela</th>
                  <th>Vencimento</th>
                  <th class="vrc-num">Valor</th>
                  <th class="vrc-num">Taxa</th>
                  @if (s.totalTarifa > 0) { <th class="vrc-num">Tarifa</th> }
                  <th class="vrc-num">Líquido</th>
                </tr>
              </thead>
              <tbody>
                @for (p of s.parcelas; track p.numeroParcela) {
                  <tr>
                    <td>{{ p.numeroParcela }}/{{ s.parcelas.length }}</td>
                    <td>{{ p.vencimento | date: 'dd/MM/yyyy' }}</td>
                    <td class="vrc-num">{{ p.valor | abnt: 'preco' : 2 }}</td>
                    <td class="vrc-num">{{ p.taxa | abnt: 'preco' : 2 }}</td>
                    @if (s.totalTarifa > 0) { <td class="vrc-num">{{ p.tarifa | abnt: 'preco' : 2 }}</td> }
                    <td class="vrc-num">{{ p.liquido | abnt: 'preco' : 2 }}</td>
                  </tr>
                }
              </tbody>
            </table>
            <p class="vrc-apoio">
              Taxa de {{ s.taxa | abnt: 'quantidade' : 2 }}%, líquido total {{ s.totalLiquido | abnt: 'preco' : 2 }}. Os vencimentos seguem o prazo do intermediador.
              @if (s.tarifaSeparada; as t) {
                Tarifa de {{ t.valor | abnt: 'preco' : 2 }} lançada em {{ t.data | date: 'dd/MM/yyyy' }} como saída na conta {{ t.conta }}.
              }
            </p>
          </div>
        } @else {
          <div class="row">
            <div class="col-6 col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Juros da condição (%)</mat-label>
                <input matInput [value]="s.taxa | abnt: 'quantidade' : 2" disabled class="vrc-num">
              </mat-form-field>
            </div>
            <div class="col-6 col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Juros previstos</mat-label>
                <input matInput [value]="s.totalJuros | abnt: 'preco' : 2" disabled class="vrc-num">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Total com juros</mat-label>
                <input matInput [value]="s.totalComJuros | abnt: 'preco' : 2" disabled class="vrc-num">
              </mat-form-field>
            </div>
          </div>
          <p class="vrc-apoio">Os juros da condição "{{ s.nomeCondicao }}" ficam previstos em cada parcela do título. As parcelas somam o valor do recebimento e o pedido não muda.</p>
        }
      }
    }

    <!-- A grade só existe onde existe condição da EMPRESA (§8.2): à vista e cartões não a têm. -->
    @if (perfil.grade) {
      <app-vd-parcelas
        [recebimento]="recebimento"
        [dataEmissao]="dataEmissao"
        [ehOrcamento]="ehOrcamento"
        [isSomenteLeitura]="isSomenteLeitura"
        [isNsuObrigatorio]="isNsuObrigatorio && viraTitulo"
        [isObservacaoParcelaObrigatoria]="isObservacaoParcelaObrigatoria && viraTitulo"
        [mascaraDinheiro]="mascaraDinheiro"
        [mascaraInteira]="mascaraInteira">
      </app-vd-parcelas>
    }
  }
</div>
